import { Product } from '~app/modules/account/modules/buy-again/models';
import { Attribute, RepairabilityLabel } from '~app/modules/product/models';
import { environment } from '~env/environment';
import {
  RepairabilityAttributesTypes
} from "~shared/modules/repairability-label/models/repairability-attributes-enum";

const fixedIndexValue = 10;
const BaseImageUrl = `${environment.cdnBaseUrl()}/images/`;

export namespace RepairabilityLabelUtils {


  export function getRepairability(product: Product, isImageHasLabel?: boolean): RepairabilityLabel {
    const repairabilityAttr: Attribute = this.checkRepairabilityAttribute(product);
    if (!repairabilityAttr) {
      return null;
    } else {
      return this.setRepairabilityLabelAttributes(product, isImageHasLabel);
    }
  }

  export function checkRepairabilityAttribute(product: Product): Attribute {
    return product?.attributes?.find(
      (attribute: Attribute): boolean => attribute.code === RepairabilityAttributesTypes.RepairabilityIndex
    );
  }

  export function setRepairabilityLabelAttributes(product: Product, isImageHasLabel = false): RepairabilityLabel {
    const repairabilityAttribute: Attribute = product?.attributes?.find(
      (attribute: Attribute): boolean => attribute.code === RepairabilityAttributesTypes.RepairabilityIndex
    );
    const srcDataSheet: Attribute = product?.attributes?.find(
      (attribute: Attribute): boolean => attribute.code === RepairabilityAttributesTypes.RepairabilityIndexDatasheet
    );
    const imageName = `repairability-${parseFloat(repairabilityAttribute.value.replace(",", ".")) * fixedIndexValue}.svg`;
    const imagePath = isImageHasLabel ? "repairability-labels-medium" : "repairability-labels-small"
    const imageUrl = `${BaseImageUrl}${imagePath}/${imageName}`;

    return {
      index: repairabilityAttribute.value,
      src: srcDataSheet.value,
      imageUrl,
      label: repairabilityAttribute.label
    };
  }
}
